import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';

type GenericExternalFilesAddErrorDialogProps = {
  open: boolean;
  attemptedAddInvolvesMultipleFiles: boolean;
  onClose: () => void;
};

const GenericExternalFilesAddErrorDialog = ({
  open,
  attemptedAddInvolvesMultipleFiles,
  onClose,
}: GenericExternalFilesAddErrorDialogProps) => (
  <Dialog open={open} onClose={onClose} dangerous>
    <Dialog.Title>
      <FormattedMessage
        id={`portfolio.challenge.files.add.generic_error_dialogs.external_file_add.title.${attemptedAddInvolvesMultipleFiles ? 'plural' : 'singular'}`}
      />
    </Dialog.Title>
    <Dialog.Content>
      <Dialog.ContentText>
        <FormattedMessage
          id={`portfolio.challenge.files.add.generic_error_dialogs.external_file_add.text.${attemptedAddInvolvesMultipleFiles ? 'plural' : 'singular'}`}
        />
      </Dialog.ContentText>
    </Dialog.Content>
    <Dialog.Actions>
      <Dialog.Actions.DeleteButton onClick={onClose}>
        <FormattedMessage id="dialogs.actions.ok" />
      </Dialog.Actions.DeleteButton>
    </Dialog.Actions>
  </Dialog>
);

export default GenericExternalFilesAddErrorDialog;
